module.exports = __webpack_public_path__ + "img/tertiary_2x2_z16.7dbe63bb.svg";